import { IBulletPointProps } from "./BulletPoint";

export const View = (props: IBulletPointProps) => {
  return (
    <div
      className={`flex-container no-wrap bullet-point--container ${props.className}`}
    >
      <div className="bullet-point--icon">{props.icon}</div>

      <div className="bullet-point--content">
        <h3 className="bullet-point--title font-ctm--bold">{props.title}</h3>
        <p className="bullet-point--description text-secondary">
          {props.description}
        </p>
      </div>
    </div>
  );
};
